import { render, staticRenderFns } from "./ArtDetective.vue?vue&type=template&id=09d9a591&scoped=true"
import script from "./ArtDetective.vue?vue&type=script&lang=js"
export * from "./ArtDetective.vue?vue&type=script&lang=js"
import style0 from "./ArtDetective.vue?vue&type=style&index=0&id=09d9a591&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d9a591",
  null
  
)

export default component.exports